import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  customNotificationsModal: {
    '& .modalBody': {
      '& .modalBodyScroll': {
        '& > .contentArea': {
          '&.row': {
            display: 'flex',
            alignItems: 'center',
            gap: '12px',

            '& > label': {
              display: 'flex',
              gap: '6px',

              '@media screen and (min-width: 1441px)': {
                gap: '8px',
              },
            },

            '& > .viboIcon:first-of-type': {
              color: 'var(--text-secondary)',
            },

            '& > .error': {
              position: 'relative',
              marginLeft: 'auto',
            },

            '& .viboInputWrapper': {
              width: 'fit-content',

              '& .viboInput[type="number"]': {
                maxWidth: '38px',

                '@media screen and (min-width: 1441px)': {
                  maxWidth: '42px',
                },
              },
            },

            '& .viboSelect__control': {
              height: 'auto',
            },

            '@media screen and (min-width: 1441px)': {
              gap: '16px',
            },
          },

          '@media screen and (min-width: 1441px)': {
            padding: '16px 24px',
          },
        },
      },
    },
  },

  selectTimeSettingMenu: {
    '& .viboScrollbar': {
      maxHeight: '100px',

      '@media screen and (min-width: 1441px)': {
        maxHeight: '150px',
      },
    },
  },
}));

export default useStyles;
